import React, { useCallback, useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Tooltip, Table, LoadingIndicator } from '@components';
import { useSelector } from 'react-redux';
import { AlteracaoPercentualContribuicaoService } from '@services';

export const HistoricoMudancaPercentualContribuicao = () => {
  const users = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [historico, setHistorico] = useState([]);

  const getHistoricoMudancaPerfil = useCallback(async () => {
    setLoading(true);
    const alteracaoPercentualService =
      new AlteracaoPercentualContribuicaoService();
    const historicoIntencaoTroca =
      await alteracaoPercentualService.getHistoricoMudancaPercentualContribuicao(
        users.matricula
      );
    setHistorico(historicoIntencaoTroca);
    setLoading(false);
  }, [users.matricula]);

  useEffect(() => {
    getHistoricoMudancaPerfil();
  }, [getHistoricoMudancaPerfil]);

  return !loading ? (
    <>
      <Helmet>
        <title>Histórico Mudança de Percentual de Contribuição</title>
      </Helmet>
      <div className="card">
        <div className="card-body">
          <span className="fw-bold ts-10 mb-32 mb-md-5">
            Histórico Mudança de Percentual de Contribuição
            <Tooltip title="Veja o Histórico Mudança de Percentual de Contribuição">
              ?
            </Tooltip>
          </span>
          <Table
            className=" mb-4 mt-32"
            odd
            columns={[
              'Tipo de Contribuição',
              'Perc. de Contribuição',
              'Data Início Vigência',
              'Data Solicitação',
              'Data Hora Registro',
            ]}
          >
            {historico.map((linha) => {
              return (
                <tr key={linha.DataHoraRegistro}>
                  <td>{linha.DescricaoTipoContribuicao}</td>
                  <td>{linha.PercentualContribuicao}</td>
                  <td>{linha.DataInicioVigencia}</td>
                  <td>{linha.DataSolicitacao}</td>
                  <td>{linha.DataHoraRegistro}</td>
                </tr>
              );
            })}
          </Table>
        </div>
      </div>
    </>
  ) : (
    <LoadingIndicator />
  );
};
